"use client";

import Link from "next/link";
import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "@/app/_partials/_sections/_hooks/useSection";
import PageSkeleton from "@/app/(frontend)/[page_slug]/skeleton/PageSkeleton";

export const AboutBanner = () => {
    const { trans } = useUtility();
    const { content, loading } = useSection("about_banner");

    if (loading) {
        return <PageSkeleton />;
    }

    return (
        <section className="about-banner-section section-bg">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {/* Breadcrumb */}
                        <ul className="breadcrumb-list">
                            <li className="breadcrumb-list__item">
                                <Link href="/" className="breadcrumb-list__link">
                                    {trans("Home")}
                                </Link>
                            </li>
                            <li className="breadcrumb-list__item">
                                <i className="fa-solid fa-chevron-right"></i>
                            </li>
                            <li className="breadcrumb-list__item">
                                <span className="breadcrumb-list__link">{trans("Company")}</span>
                            </li>
                            <li className="breadcrumb-list__item">
                                <i className="fa-solid fa-chevron-right"></i>
                            </li>
                            <li className="breadcrumb-list__item">
                                <span className="breadcrumb-list__text">{trans("About us")}</span>
                            </li>
                        </ul>

                        {/* Main About Banner */}
                        <div className="about-banner text-center">
                            <h2 className="about-banner__title">{trans(content?.title)}</h2>
                            <p className="about-banner__desc">{trans(content?.description)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
